/* import React, { useState, useRef, useEffect } from "react";
import { FaPlay, FaPause } from "react-icons/fa";
import "./AudioPlayer.css";

const AudioPlayer = ({ src, audioDuration }) => {
  console.log("audio duration",audioDuration);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(audioDuration || 0);

  const audioRef = useRef(null);

  useEffect(() => {
    if (audioDuration && audioDuration > 0) {
      setDuration(audioDuration);
    }

    const audio = audioRef.current;
    audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    audio.addEventListener("timeupdate", updateTime);

    return () => {
      audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
      audio.removeEventListener("timeupdate", updateTime);
    };
  }, [audioDuration]);

  const handleLoadedMetadata = () => {
    const audio = audioRef.current;
    const loadedDuration = audio.duration;

    if (!isNaN(loadedDuration) && loadedDuration !== Infinity) {
      setDuration(loadedDuration);
    } else if (audioDuration && audioDuration > 0) {
      setDuration(audioDuration);
    } else {
      setDuration(0);
    }
  };

  const togglePlayPause = () => {
    const audio = audioRef.current;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const updateTime = () => {
    setCurrentTime(audioRef.current.currentTime || 0);
    if (!audioDuration) {
      const audioDur = audioRef.current.duration;
      if (!isNaN(audioDur) && audioDur !== Infinity) {
        setDuration(audioDur);
      }
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };

  const progress = duration ? (currentTime / duration) * 100 : 0;

  return (
    <div className="audio-player">
      <button className="play-pause-btn" onClick={togglePlayPause}>
        {isPlaying ? (
          <FaPause title="Pause Audio" size={15} color="white" />
        ) : (
          <FaPlay title="Play Audio" size={15} color="white" />
        )}
      </button>
      <div className="waveform">
        <div className="progress-bar" style={{ width: `${progress}%` }}></div>
      </div>
      <div className="time">
        {formatTime(currentTime)} /{" "}
        {isNaN(duration) || duration === Infinity
          ? "0:00"
          : formatTime(duration)}
      </div>
      <audio
        ref={audioRef}
        preload="auto"
        src={src}
        onTimeUpdate={updateTime}
        onLoadedMetadata={handleLoadedMetadata}
        onEnded={() => setIsPlaying(false)}
      ></audio>
    </div>
  );
};

export default AudioPlayer;
 */

// import React, { useState, useRef, useEffect } from "react";
// import { FaPlay, FaPause } from "react-icons/fa";
// import styles from "./AudioPlayer.module.css";

// const AudioPlayer = ({ src, audioDuration, isSent = false }) => {
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(audioDuration || 0);
//   const audioRef = useRef(null);

//   useEffect(() => {
//     if (audioDuration && audioDuration > 0) {
//       setDuration(audioDuration);
//     }

//     const audio = audioRef.current;
//     const events = [
//       { name: "loadedmetadata", handler: handleLoadedMetadata },
//       { name: "timeupdate", handler: updateTime },
//       { name: "ended", handler: () => setIsPlaying(false) }
//     ];

//     events.forEach(({ name, handler }) => audio.addEventListener(name, handler));

//     return () => {
//       events.forEach(({ name, handler }) =>
//         audio.removeEventListener(name, handler)
//       );
//     };
//   }, [audioDuration]);

//   const handleLoadedMetadata = () => {
//     const audio = audioRef.current;
//     if (audio.duration !== Infinity && !isNaN(audio.duration)) {
//       setDuration(audio.duration);
//     } else if (audioDuration) {
//       setDuration(audioDuration);
//     } else {
//       setDuration(0);
//     }
//   };

//   const togglePlayPause = () => {
//     const audio = audioRef.current;
//     if (isPlaying) {
//       audio.pause();
//     } else {
//       audio.play();
//     }
//     setIsPlaying(!isPlaying);
//   };

//   const updateTime = () => {
//     setCurrentTime(audioRef.current.currentTime);
//   };

//   const formatTime = (time) => {
//     if (isNaN(time) || !isFinite(time)) return "0:00";
//     const minutes = Math.floor(time / 60);
//     const seconds = Math.floor(time % 60);
//     return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
//   };

//   const progress = duration ? (currentTime / duration) * 100 : 0;

//   return (
//     <div className={`${styles.audioPlayer} ${isSent ? styles.sent : styles.received}`}>
//       <button
//         className={styles.playButton}
//         onClick={togglePlayPause}
//         aria-label={isPlaying ? "Pause" : "Play"}
//       >
//         {isPlaying ? (
//           <FaPause size={12} />
//         ) : (
//           <FaPlay size={12} style={{ marginLeft: "2px" }} />
//         )}
//       </button>

//       <div className={styles.progressContainer}>
//         <div
//           className={styles.progressBar}
//           style={{ width: `${progress}%` }}
//         ></div>
//       </div>

//       <div className={styles.time}>
//         {formatTime(isPlaying ? currentTime : duration)}
//       </div>

//       <audio
//         ref={audioRef}
//         preload="metadata"
//         src={src}
//         onEnded={() => setIsPlaying(false)}
//       />
//     </div>
//   );
// };

// export default AudioPlayer;

import React, { useState, useRef, useEffect } from "react";
import { FaPlay, FaPause } from "react-icons/fa";
import styles from "./AudioPlayer.module.css";

const AudioPlayer = ({ src, audioDuration, isSent = false }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(audioDuration || 0);
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioDuration && audioDuration > 0) {
      setDuration(audioDuration);
    }

    const audio = audioRef.current;
    const events = [
      { name: "loadedmetadata", handler: handleLoadedMetadata },
      { name: "timeupdate", handler: updateTime },
      { name: "ended", handler: () => setIsPlaying(false) },
    ];

    events.forEach(({ name, handler }) =>
      audio.addEventListener(name, handler)
    );

    return () => {
      events.forEach(({ name, handler }) =>
        audio.removeEventListener(name, handler)
      );
    };
  }, [audioDuration, src]); // Added src as dependency

  const handleLoadedMetadata = () => {
    const audio = audioRef.current;
    if (audio.duration !== Infinity && !isNaN(audio.duration)) {
      setDuration(audio.duration);
    } else if (audioDuration) {
      setDuration(audioDuration);
    } else {
      setDuration(0);
    }
  };

  const togglePlayPause = () => {
    const audio = audioRef.current;
    if (isPlaying) {
      audio.pause();
    } else {
      // Add error handling for play
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.error("Play error:", error);
          setIsPlaying(false);
        });
      }
    }
    setIsPlaying(!isPlaying);
  };

  const updateTime = () => {
    setCurrentTime(audioRef.current.currentTime || 0);

    // Update duration if it wasn't available initially
    if (!audioDuration) {
      const audioDur = audioRef.current.duration;
      if (!isNaN(audioDur) && audioDur !== Infinity) {
        setDuration(audioDur);
      }
    }
  };

  const formatTime = (time) => {
    if (isNaN(time) || !isFinite(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };

  const progress = duration ? (currentTime / duration) * 100 : 0;

  return (
    <div
      className={`${styles.audioPlayer} ${
        isSent ? styles.sent : styles.received
      }`}
    >
      <button
        className={styles.playButton}
        onClick={togglePlayPause}
        aria-label={isPlaying ? "Pause" : "Play"}
      >
        {isPlaying ? (
          <FaPause size={12} />
        ) : (
          <FaPlay size={12} style={{ marginLeft: "2px" }} />
        )}
      </button>

      <div className={styles.progressContainer}>
        <div
          className={styles.progressBar}
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      <div className={styles.time}>
        {formatTime(currentTime)} / {formatTime(duration)}
      </div>

      <audio ref={audioRef} preload="auto" src={src} />
    </div>
  );
};

export default AudioPlayer;
